import { ChevronDown } from "lucide-react";
import SearchResultItem from "../SearchResultItem";

const SearchResults = ({
  results,
  isLoading,
  searchQuery,
  activeTab,
  onSelectResult,
  subqueries,
  focusedIndex,
}) => {
  if (searchQuery.trim() === "") {
    return (
      <div className="py-8 text-center text-gray-500">
        <p>Nhập từ khóa để tìm kiếm</p>
      </div>
    );
  }

  if (isLoading && results.length === 0) {
    return (
      <div className="py-2">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="flex items-start gap-3 px-4 py-3 animate-pulse">
            <div className="w-10 h-10 bg-gray-200 rounded-full" />
            <div className="flex-1 space-y-2">
              <div className="h-3 bg-gray-200 rounded w-1/2" />
              <div className="h-3 bg-gray-100 rounded w-3/4" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (results.length === 0) {
    return (
      <div className="py-8 text-center text-gray-500">
        <p>
          Không tìm thấy kết quả cho{" "}
          <span className="font-medium text-gray-700">
            "{searchQuery}"
          </span>
        </p>
        <p className="text-xs text-gray-400 mt-1">
          Thử từ khóa khác, xóa lọc hoặc đổi tab
        </p>
      </div>
    );
  }

  return (
    <div>
      {results.map((result, idx) => (
        <SearchResultItem
          key={result._id}
          result={result}
          searchQuery={searchQuery}
          activeTab={activeTab}
          onClick={onSelectResult}
          subqueries={subqueries}
          isFocused={idx === focusedIndex}
        />
      ))}
    </div>
  );
};

export default SearchResults;
